export function offsetWithin(element, ancestor) {
    let x = 0;
    let y = 0;

    for (let node = element; node && node !== ancestor; node = node.offsetParent) {
        x += node.offsetLeft;
        y += node.offsetTop;
    }

    return { x, y };
}

export function logoTileDeltaY(config, logoHeight) {
    const centered = Math.round((config.bannerHeight - (logoHeight || 0)) / 2) + config.logo.offsetY;
    return centered - config.bannerTile.offsetY;
}

export function tileSnapShift(offset, period) {
    if (!period || period <= 0) return 0;
    return ((Math.round(offset) % period) + period) % period;
}

export function firstItemAnchor(row, ancestor, itemHeight) {
    const pos = offsetWithin(row, ancestor);
    const style = window.getComputedStyle(row);
    const padLeft = parseFloat(style.paddingLeft) || 0;
    const padTop = parseFloat(style.paddingTop) || 0;
    const padBottom = parseFloat(style.paddingBottom) || 0;
    const inner = row.clientHeight - padTop - padBottom;

    return {
        x: pos.x + padLeft,
        y: pos.y + padTop + Math.round((inner - (itemHeight || 0)) / 2)
    };
}

export function rowShortfall(row) {
    const maxWidth = parseFloat(window.getComputedStyle(row).maxWidth);
    if (!Number.isFinite(maxWidth)) return 0;

    return Math.round(row.offsetWidth - maxWidth);
}
